import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

import { PropsWithChildren } from 'react';
import Text from '../../../react-components/Text';
import { FieldMapping } from '../fields/FieldMapping';

export const ROW_HEIGHT = 46;

const TextWithLineClamp = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Text
      style={{
        display: `-webkit-box`,
        WebkitBoxOrient: `vertical`,
        WebkitLineClamp: 2,
        overflow: `hidden`,
        textOverflow: `ellipsis`,
      }}
    >
      {children}
    </Text>
  );
};

const ExcelRow = styled(Grid)`
  padding: 8px;
  height: 36px;
`;

interface MapFieldsColumnRowProps {
  index: number;
  style: any;
  data: {
    mapping: FieldMapping;
    columnIndex: number;
  };
}

export const MapFieldsColumnRow = ({ index, style, data }: MapFieldsColumnRowProps) => {
  const { mapping, columnIndex } = data;

  const columnData = mapping.getDataByColumnIndex(columnIndex);

  const item = columnData[index];

  const mappingItem = mapping.getByColumnIndex(columnIndex);

  let backgroundColor = `transparent`;

  if (mappingItem?.field) {
    // Empty field must show warnings
    const hasWarning = !item;

    if (hasWarning) {
      backgroundColor = `${RoutalPalette.warning.medium}33`;
    }

    const hasError = mappingItem?.field ? !FieldMapping.validate(mappingItem.field, item) : false;

    if (hasError) {
      backgroundColor = `${RoutalPalette.error.medium}33`;
    }
  }

  return (
    <ExcelRow
      container
      direction="row"
      alignItems="center"
      style={{
        ...style,
        borderTop: index !== 0 ? `1px solid ${RoutalPalette.grey4}` : `none`,
        backgroundColor: backgroundColor,
      }}
    >
      <Grid item>
        <TextWithLineClamp>{item ?? ``}</TextWithLineClamp>
      </Grid>
    </ExcelRow>
  );
};
